import React from 'react';
import { Link } from 'react-router-dom';
import UserStrip from '../components/dashboard/UserStrip';
import ReferralInline from '../components/dashboard/ReferralInline';
import StatsSix from '../components/dashboard/StatsSix';
import TradingProfitCard from '../components/dashboard/TradingProfitCard';
import ClaimMegaCard from '../components/dashboard/ClaimMegaCard';
import IncomeBreakdownCard from '../components/dashboard/IncomeBreakdownCard';
import CeilingCard from '../components/dashboard/CeilingCard';
import RecentActivity from '../components/dashboard/RecentActivity';
import EmptyState from '../components/common/EmptyState';
import { useContractState } from '../context/ContractContext';
import { formatUSDT } from '../utils/format';

export default function Dashboard() {
  const { userId, basic, loaded } = useContractState();

  if (!loaded) {
    return <div className="page"><div className="card"><div className="spinner" style={{ margin: '30px auto' }} /></div></div>;
  }

  if (userId === 0) {
    return (
      <div className="page">
        <UserStrip />
        <EmptyState icon="🚀" title="Start your journey" msg="Register with a referrer ID and make your first stake." action={
          <Link to="/invest" className="btn btn-primary btn-lg btn-block" style={{ textDecoration: 'none' }}>Register & Invest</Link>
        } />
      </div>
    );
  }

  return (
    <div className="page">
      {/* 1. User strip: avatar, ID, upline, wallet */}
      <UserStrip />

      {/* 2. Portfolio value */}
      <div className="card card-hero dash-hero">
        <div className="greet">Portfolio Value</div>
        <div className="amount">{formatUSDT(basic && basic.totalInvestment)}</div>
        <div className="sub">Total earned {formatUSDT(basic && basic.totalEarned)}</div>
      </div>

      {/* 3. Referral link with copy */}
      <ReferralInline />

      {/* 4. 6 stats: invested, earned, active directs, team count, direct biz, team biz */}
      <StatsSix />

      {/* 6. Trading profit + start trade + timer */}
      <TradingProfitCard />

      {/* 7. Big claim card */}
      <ClaimMegaCard />

      {/* 8. Income breakdown chart */}
      <IncomeBreakdownCard />

      {/* 9. Total ceiling + packages progress */}
      <CeilingCard />

      {/* 10. Recent history (5 + view all → 10 paginated) */}
      <RecentActivity />
    </div>
  );
}
